import WebFooter from "../../../components/website/webFooter/WebFooter";
import WebHeader from "../../../components/website/webHeader/WebHeader";

export default function Pricing() {
  return (
    <>
      <WebHeader />
      <div className="page active" id="page-pricing">
        <section className="page-hero">
          <div className="hero-bg" />
          <div className="wrap">
            <span className="eyebrow">
              <span className="dot" />
              Pricing
            </span>
            <h1>
              Simple pricing.
              <br />
              Pay per bed, not per user.
            </h1>
            <p>
              Start with a 14-day free trial. No credit card. Cancel anytime.
              Your data stays yours, forever.
            </p>
            <div className="pricing-toggle">
              <button
                className="active"
                data-cycle="monthly"
                onclick="togglePricing('monthly')"
              >
                Monthly
              </button>
              <button data-cycle="yearly" onclick="togglePricing('yearly')">
                Yearly <span className="save">Save 20%</span>
              </button>
            </div>
          </div>
        </section>
        <section style={{ padding: "20px 0 60px" }}>
          <div className="wrap">
            <div className="plans">
              <div className="plan">
                <div className="plan-name">Starter</div>
                <div className="plan-sub">
                  Single property, getting organized.
                </div>
                <div className="plan-price">
                  <span className="cur">₹</span>
                  <span
                    className="amt"
                    data-price=""
                    data-monthly={12}
                    data-yearly={10}
                  >
                    12
                  </span>
                  <span className="per">/ bed / month</span>
                </div>
                <div className="plan-note">Up to 30 beds · ₹360/mo minimum</div>
                <hr />
                <ul className="plan-feats">
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Bed-level inventory</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Auto rent + UPI collection</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Text complaints</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>500 SMS/month</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Email support</span>
                  </li>
                </ul>
                <button className="btn" onclick="goTo('auth','signup')">
                  Start free trial
                </button>
              </div>
              <div className="plan plan-featured">
                <div className="plan-badge">Most popular</div>
                <div className="plan-name">Growth</div>
                <div className="plan-sub">
                  Multi-property operators with staff.
                </div>
                <div className="plan-price">
                  <span className="cur">₹</span>
                  <span
                    className="amt"
                    data-price=""
                    data-monthly={20}
                    data-yearly={16}
                  >
                    20
                  </span>
                  <span className="per">/ bed / month</span>
                </div>
                <div className="plan-note">
                  Up to 250 beds · 5 staff accounts
                </div>
                <hr />
                <ul className="plan-feats">
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Everything in Starter</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Food management</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Voice tickets + AI transcription</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>WhatsApp Business API</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Full analytics suite</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Priority chat support</span>
                  </li>
                </ul>
                <button
                  className="btn btn-primary"
                  onclick="goTo('auth','signup')"
                >
                  Start free trial
                </button>
              </div>
              <div className="plan">
                <div className="plan-name">Pro</div>
                <div className="plan-sub">
                  Chains &amp; real estate operators.
                </div>
                <div className="plan-price">
                  <span className="cur">₹</span>
                  <span
                    className="amt"
                    data-price=""
                    data-monthly={32}
                    data-yearly={26}
                  >
                    32
                  </span>
                  <span className="per">/ bed / month</span>
                </div>
                <div className="plan-note">
                  Unlimited beds · unlimited staff · custom SLA
                </div>
                <hr />
                <ul className="plan-feats">
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Everything in Growth</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Multi-branch hierarchy</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>API + Zapier/Make</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Tally / Zoho Books sync</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>White-label tenant portal</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Dedicated account manager</span>
                  </li>
                </ul>
                <button className="btn" onclick="goTo('contact')">
                  Talk to sales
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="compare">
          <div className="wrap">
            <h2>Compare plans</h2>
            <p className="compare-sub">
              Every feature, side-by-side. No asterisks.
            </p>
            <table className="compare-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Starter</th>
                  <th className="pop">Growth</th>
                  <th>Pro</th>
                </tr>
              </thead>
              <tbody>
                <tr className="sect">
                  <td colSpan={4}>Property &amp; tenant management</td>
                </tr>
                <tr>
                  <td>Properties</td>
                  <td>1</td>
                  <td className="pop">Up to 10</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Beds</td>
                  <td>Up to 30</td>
                  <td className="pop">Up to 250</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Staff accounts</td>
                  <td>1</td>
                  <td className="pop">5</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Tenant records with KYC</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>DigiLocker integration</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr className="sect">
                  <td colSpan={4}>Billing &amp; payments</td>
                </tr>
                <tr>
                  <td>Auto invoice generation</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>UPI collection (0% fee)</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Cards &amp; net-banking</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Adhoc charges &amp; adjustments</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Tally / Zoho Books sync</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr className="sect">
                  <td colSpan={4}>Food management</td>
                </tr>
                <tr>
                  <td>Weekly menu planner</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Veg/non-veg/Jain plans</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Guest meals &amp; skip notices</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Waste &amp; cost reports</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr className="sect">
                  <td colSpan={4}>Complaints / Tickets</td>
                </tr>
                <tr>
                  <td>Text complaints</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Voice tickets + AI transcription</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Auto-categorization &amp; routing</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>SLA tracking &amp; alerts</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Custom SLAs per category</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr className="sect">
                  <td colSpan={4}>Communications</td>
                </tr>
                <tr>
                  <td>SMS reminders (DLT-compliant)</td>
                  <td>500/mo</td>
                  <td className="pop">5,000/mo</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>WhatsApp Business API</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Email &amp; push notifications</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Multi-language (10 Indian languages)</td>
                  <td>English only</td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr className="sect">
                  <td colSpan={4}>Analytics &amp; reporting</td>
                </tr>
                <tr>
                  <td>Occupancy &amp; revenue dashboard</td>
                  <td>Basic</td>
                  <td className="pop">Full</td>
                  <td>Full + custom</td>
                </tr>
                <tr>
                  <td>Cross-property comparison</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>AI-generated insights</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Custom reports &amp; exports</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr className="sect">
                  <td colSpan={4}>Advanced</td>
                </tr>
                <tr>
                  <td>API access</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Zapier / Make integrations</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>White-label tenant portal</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Custom branding</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr className="sect">
                  <td colSpan={4}>Support &amp; security</td>
                </tr>
                <tr>
                  <td>Support channel</td>
                  <td>Email</td>
                  <td className="pop">Priority chat</td>
                  <td>Dedicated AM + phone</td>
                </tr>
                <tr>
                  <td>Response SLA</td>
                  <td>24 hrs</td>
                  <td className="pop">4 hrs</td>
                  <td>1 hr · 24×7</td>
                </tr>
                <tr>
                  <td>Data encryption (TLS + AES-256)</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Daily backups</td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                  <td className="pop">
                    <span className="tick-y">●</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
                <tr>
                  <td>Custom BAA / DPA</td>
                  <td>
                    <span className="tick-n">—</span>
                  </td>
                  <td className="pop">
                    <span className="tick-n">—</span>
                  </td>
                  <td>
                    <span className="tick-y">●</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <WebFooter />
    </>
  );
}
